module.exports = __webpack_public_path__ + "static/media/SBPhotography_1-360w.ae623d76.webp";